import { apiClient } from './client';
import {
  DashboardStatistics,
  StatusType,
  ExpiringContract as BaseExpiringContract,
  ContractConsumption as BaseContractConsumption,
  ChartData,
} from '@console/utils';

// Frontend-specific interface with string dates for API responses
export interface ExpiringContract extends Omit<BaseExpiringContract, 'expirationDate'> {
  expirationDate: string;
}

export interface ContractConsumption extends Omit<BaseContractConsumption, 'contractEndDate'> {
  contractEndDate: string | null;
}

export type { DashboardStatistics, StatusType, ChartData };

export const dashboardApi = {
  getStatistics: async (): Promise<DashboardStatistics> => {
    const response = await apiClient.get('/dashboard/statistics');
    return response.data;
  },

  getExpiringContracts: async (days?: number): Promise<ExpiringContract[]> => {
    const params = days ? `?days=${days}` : '';
    const response = await apiClient.get(`/dashboard/expiring-contracts${params}`);
    return response.data;
  },

  getContractConsumption: async (contractId: string): Promise<ContractConsumption> => {
    const response = await apiClient.get(`/dashboard/contract-consumption/${contractId}`);
    return response.data;
  },

  getTicketsChart: async (
    contractId: string,
    startDate?: string,
    endDate?: string
  ): Promise<ChartData> => {
    const searchParams = new URLSearchParams();
    searchParams.append('contractId', contractId);
    if (startDate) searchParams.append('startDate', startDate);
    if (endDate) searchParams.append('endDate', endDate);

    const response = await apiClient.get(
      `/dashboard/tickets-chart/${contractId}?${searchParams.toString()}`
    );
    return response.data;
  },

  getHoursChart: async (
    contractId: string,
    startDate?: string,
    endDate?: string
  ): Promise<ChartData> => {
    const searchParams = new URLSearchParams();
    searchParams.append('contractId', contractId);
    if (startDate) searchParams.append('startDate', startDate);
    if (endDate) searchParams.append('endDate', endDate);

    const response = await apiClient.get(
      `/dashboard/hours-chart/${contractId}?${searchParams.toString()}`
    );
    return response.data;
  },
};
